import { POSITIONS } from "@/lib/football";

export const PositionPicker = ({ value, onChange, multi = false, exclude, testid = "position", codes }) => {
  const isOn = (c) => (multi ? value.includes(c) : value === c);
  const toggle = (c) => (multi ? onChange(isOn(c) ? value.filter((v) => v !== c) : [...value, c]) : onChange(c));
  return (
    <div className="grid grid-cols-2 gap-2">
      {POSITIONS.filter((p) => p.code !== exclude && (!codes || codes.includes(p.code))).map((p) => (
        <button type="button" key={p.code} data-testid={`${testid}-${p.code}`} onClick={() => toggle(p.code)}
          className={`rounded-2xl border px-3 py-3 text-left transition-colors active:scale-[0.97] ${isOn(p.code) ? "bg-cyan-400 border-cyan-300 text-zinc-950" : "bg-white border-slate-200 text-slate-700"}`}>
          <span className="num text-[11px] font-bold opacity-70 block">{p.code}</span>
          <span className="text-sm font-semibold">{p.label}</span>
        </button>
      ))}
    </div>
  );
};
